import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";

const GlobalLoaderBar = ({ open }) => {
  if (!open) return null;

  return (
    <Box
      sx={(theme) => ({
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 4,
        zIndex: theme.zIndex.snackbar + 2,
        pointerEvents: "none",
        backgroundColor: alpha(theme.palette.primary.main, 0.16),
        boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.25)}`,
        overflow: "hidden",
        "@keyframes loaderSlide": {
          "0%": { transform: "translateX(-120%)" },
          "100%": { transform: "translateX(220%)" },
        },
      })}
    >
      <Box
        sx={(theme) => ({
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "45%",
          background: `linear-gradient(90deg, ${alpha(
            theme.palette.primary.dark,
            0
          )} 0%, ${alpha(theme.palette.primary.light, 0.65)} 35%, ${
            theme.palette.primary.main
          } 50%, ${alpha(theme.palette.primary.light, 0.65)} 65%, ${alpha(
            theme.palette.primary.dark,
            0
          )} 100%)`,
          animation: "loaderSlide 1.4s ease-in-out infinite",
        })}
      />
    </Box>
  );
};

GlobalLoaderBar.propTypes = {
  open: PropTypes.bool,
};

GlobalLoaderBar.defaultProps = {
  open: false,
};

export default GlobalLoaderBar;
